import { FORMS } from "../../../../const";
import LoadingSpinner from "../../../LoadingSpinner";
import React, { useEffect, useRef, useState } from "react";
import Dropdown from "../../../input/Dropdown";
import SearchDropdown from "../../../input/SearchDropdown";
import {
  getBulkDropdownData,
  getDropdownData,
  getFieldValuesByTableAndId,
  getOtherRefDetails,
  getOtherRefDropdown,
  getOtherRefSearchDropdown,
  getTextByValueAndKey,
} from "../../../../api/keyvalue";
import { deductionItemById } from "../../../../api/DeductionItemApi";
import Input from "../../../input/Input";
import Button from "../../../input/Button";
import { jobOtherByJobId } from "../../../../api/jobApi";
import {
  addDeductionMaster,
  findByDedJobIdAndDedVehicle,
} from "../../../../api/finance/deductionMasterApi";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { errorActions } from "../../../../store/error-slice";
import {
  deductionMasterValidation,
  fuelAddValidation,
} from "../../../validations/DeductionCreation";

const form = FORMS.JOB.DED_FUEL.form;

const FuelQuota = ({ jobId, jobCode, stakeholder, vehicleId, close, type }) => {
  const [fuelQuotaData, setFuelQuotaData] = useState({
    fDedCode: "",
    fDedReference: "",
    fDedCompany: "",
    fDedTransporter: stakeholder,
    fDedSupplier: "",
    fDedVehicle: vehicleId,
    fDedItem: "",
    fDedItemType: type,
    fDedItemTypeName: "",
    fDedPeriod: "",
    fDedStart: "",
    fDedEnd: "",
    fDedRequiredDate: null,
    fDedExecutionDate: "",
    fDedItemCost: "",
    fDedQuantity: 1,
    fDedAmount: 0,
    fDedInstallmentAmount: null,
    fDedInstallments: 0,
    fDedPaymentStatus: 1,
    fDedJob: jobId,
    fDedJobCode: jobCode,
    fDedFuelInstruction: "",
    fDedDescription: "",
    fDedStatus: 2,
    fDedActive: 1,
  });

  const user = useSelector((state) => state.user);
  const stakeholderAvailable = stakeholder !== null;
  const vehicleAvailable = vehicleId !== null;
  const jobAvailable = jobId !== null;
  const dispatch = useDispatch();
  const errorState = useSelector((state) => state.error.deductMasterErrors);

  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);

  // flags
  const [fieldReset, setFieldReset] = useState(false);
  const [itemFieldReset, setItemFieldReset] = useState(false);
  const [installmentsDisable, setInstallmentsDisable] = useState(false);
  const [endDateDisable, setEndDateDisable] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);

  // dropdown
  const [paymentStatusOpt, setPaymentStatusOpt] = useState([]);
  const [dedStatusOpt, setDedStatusOpt] = useState([]);
  const [dedActiveOpt, setDedActiveOpt] = useState([]);
  const [dedPeriodOpt, setDedPeriodOpt] = useState([]);
  const [itemTypeOpt, setItemTypeOpt] = useState("");

  const [executionDateGap, setExecutionDateGap] = useState(null);
  const [selectedPeriod, setSelectedPeriod] = useState(null);
  const [stakeholderCode, setSetStakeholderCode] = useState("");
  const [stakeholderName, setStakeholderName] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [currentValues, setCurrentValues] = useState([]);

  //errors
  const [currentErrors, setCurrentErrors] = useState({});
  useEffect(() => {
    setCurrentErrors(errorState.deductMasterErrors);
  }, [errorState.deductMasterErrors]);

  const currentDate = fuelQuotaData.fDedStart;
  const maxDate = executionDateGap || "";

  const setCostAgainstItem = async (data) => {
    const response = await deductionItemById(data);
    setFuelQuotaData((prevState) => ({
      ...prevState,
      fDedItemCost: response[0].temPrice,
      fDedAmount: response[0].temPrice,
      fDedQuantity: 1,
    }));
  };
  const handlePeriodResult = (id) => {
    setSelectedPeriod(id);
    if (id === 1) {
      const currentDate = new Date().toISOString().split("T")[0];
      setFuelQuotaData((prevState) => ({
        ...prevState,
        fDedInstallments: 1,
        fDedStart: currentDate,
        fDedEnd: currentDate,
        fDedExecutionDate: currentDate,
      }));
      setInstallmentsDisable(true);
    } else {
      setFuelQuotaData((prevState) => ({
        ...prevState,
        fDedInstallments: "",
        fDedStart: "",
        fDedEnd: "",
        fDedExecutionDate: "",
      }));
      setInstallmentsDisable(false);
    }
  };

  const handleInstallmentDates = (data) => {
    const selectedDate = new Date(data);
    if (!data || isNaN(new Date(data))) {
      console.error("Invalid date input:", data);
      return;
    }
    if (selectedPeriod === 2) {
      selectedDate.setMonth(
        selectedDate.getMonth() + parseInt(fuelQuotaData.fDedInstallments)
      );
      setFuelQuotaData((prev) => ({
        ...prev,
        fDedStart: data,
        fDedEnd: selectedDate.toISOString().split("T")[0],
      }));
      setExecutionDateGap(selectedDate.toISOString().split("T")[0]);
    } else if (selectedPeriod === 3) {
      const daysToAdd = parseInt(fuelQuotaData.fDedInstallments) * 7;
      selectedDate.setDate(selectedDate.getDate() + daysToAdd);
      setFuelQuotaData({
        ...fuelQuotaData,
        fDedEnd: selectedDate.toISOString().split("T")[0],
      });
      setExecutionDateGap(selectedDate.toISOString().split("T")[0]);
    }

    setEndDateDisable(true);
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    setIsSubmitLoading(true);

    dispatch(errorActions.clearDeductMasterError());
    const deductMasterErrors = fuelAddValidation(fuelQuotaData);
    console.log(
      "Object.keys(deductMasterErrors).length ",
      Object.keys(deductMasterErrors).length
    );
    if (Object.keys(deductMasterErrors).length > 0) {
      dispatch(
        errorActions.validateAddFuel({
          deductMasterData: fuelQuotaData,
        })
      );
      setIsSubmitLoading(false);
      toast.error("There was an error adding Item", {
        autoClose: 5000,
        containerId: "Modal",
      });
      return;
    } else {
      const response = await addDeductionMaster({
        dedCode: "",
        dedReference: "",
        dedCompany: 1,
        dedTransporter: stakeholder,
        dedVehicle: vehicleId,
        dedItem: fuelQuotaData.fDedItem,
        dedPeriod: fuelQuotaData.fDedPeriod,
        dedStart: fuelQuotaData.fDedStart,
        dedEnd: fuelQuotaData.fDedEnd,
        dedRequiredDate: fuelQuotaData.fDedRequiredDate,
        dedExecutionDate: fuelQuotaData.fDedExecutionDate,
        dedItemCost: fuelQuotaData.fDedItemCost,
        dedQuantity: fuelQuotaData.fDedQuantity,
        dedAmount: fuelQuotaData.fDedAmount,
        dedInstallmentAmount: fuelQuotaData.fDedInstallmentAmount,
        dedInstallments: fuelQuotaData.fDedInstallments,
        dedPaymentStatus: fuelQuotaData.fDedPaymentStatus,
        dedSerialNumber: "",
        dedDescription: fuelQuotaData.fDedDescription,
        dedWarranty: null,
        dedWarrantyEnds: null,
        dedJob: jobId,
        dedDistance: null,
        dedFuelInstruction: null,
        dedBehalfOf: "",
        dedApprovalLevels: null,
        dedStatus: 2,
        dedActive: fuelQuotaData.fDedActive,
        dedSupplier: fuelQuotaData.fDedSupplier,
        author: user.username,
      });

      if (response) {
        toast.success("Fuel Added successfully!", {
          autoClose: 5000,
          containerId: "Modal",
        });
        close();
      }
      setIsSubmitLoading(false);
    }
    setFuelQuotaData({
      fDedActive: 1,
      fDedStatus: 2,
      fDedQuantity: 1,
      fDedAmount: 0,
      fDedInstallmentAmount: null,
      fDedInstallments: 0,
      fDedPaymentStatus: 1,
    });
    setIsSubmitLoading(false);
  };

  useEffect(() => {
    (async () => {
      dispatch(errorActions.clearDeductMasterError());
      setFuelQuotaData({
        fDedActive: 1,
        fDedStatus: 2,
        fDedQuantity: 1,
        fDedAmount: 0,
        fDedInstallmentAmount: null,
        fDedInstallments: 0,
        fDedPaymentStatus: 1,
      });
      setCurrentErrors({});

      setIsLoading(true);

      // new
      const {
        status,
        payment_status: paymentStatus,
        active,
        deduction_period: period,
      } = getBulkDropdownData([
        { key: "status" },
        { key: "payment_status" },
        { key: "active" },
        { key: "deduction_period" },
      ]);

      setDedStatusOpt(status);
      setPaymentStatusOpt(paymentStatus);
      setDedActiveOpt(active);
      setDedPeriodOpt(period);

      const typeName = await getTextByValueAndKey("item_type", type);
      console.log("typeName", typeName);
      setItemTypeOpt(typeName);
      if (stakeholderAvailable) {
        const stakeholderRes = await getFieldValuesByTableAndId({
          tableName: "masterdata.tms_m_stakeholder",
          primaryKey: "stk_id",
          ids: stakeholder.toString(),
          fieldNames: "stk_code, stk_name",
        });
        const jotStakeholderCode = stakeholderRes[0].field1;
        const jotStakeholderName = stakeholderRes[0].field2;

        setSetStakeholderCode(jotStakeholderCode);
        setStakeholderName(jotStakeholderName);
        setFuelQuotaData((prevState) => ({
          ...prevState,
          fDedTransporter: jotStakeholderName,
        }));
      } else {
        setCurrentErrors((prevState) => ({
          ...prevState,
          fDedTransporter: `Transporter not available for this job`,
        }));
      }

      if (vehicleAvailable) {
        const vehicleRes = await getFieldValuesByTableAndId({
          tableName: "masterdata.tms_m_vehicle_details",
          primaryKey: "veh_id",
          ids: vehicleId.toString(),
          fieldNames: "veh_vehicleno",
        });
        const vehicleNo = vehicleRes[0].field1;
        setFuelQuotaData((prevState) => ({
          ...prevState,
          fDedVehicle: vehicleNo,
        }));
      } else {
        setCurrentErrors((prevState) => ({
          ...prevState,
          fDedVehicle: `Vehicle not available for this job`,
        }));
      }

      setFuelQuotaData((prevState) => ({
        ...prevState,
        fDedJobCode: jobCode,
      }));

      const fuelData = await findByDedJobIdAndDedVehicle(jobId, vehicleId);
      console.log("fuelData", fuelData);
      setEditMode(fuelData !== "");
      setCurrentValues(fuelData);

      setIsLoading(false);
    })();
  }, [jobId, jobCode, stakeholder, vehicleId, type]);

  useEffect(() => {
    if (buttonClicked) {
      setFuelQuotaData({
        fDedCode: "",
        fDedReference: "",
        fDedCompany: "",
        fDedTransporter: "",
        fDedSupplier: "",
        fDedVehicle: "",
        fDedItem: "",
        fDedItemType: "",
        fDedItemTypeName: "",
        fDedPeriod: "",
        fDedStart: "",
        fDedEnd: "",
        fDedRequiredDate: "",
        fDedExecutionDate: "",
        fDedItemCost: "",
        fDedQuantity: 1,
        fDedAmount: 0,
        fDedInstallmentAmount: "",
        fDedInstallments: 0,
        fDedPaymentStatus: 1,
        fDedJob: jobId,
        fDedJobCode: jobCode,
        fDedFuelInstruction: "",
        fDedStatus: 2,
        fDedActive: 1,
      });
    }
  }, [buttonClicked, jobId, jobCode, stakeholder, vehicleId, type]);

  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <form className="ui form" style={{ overflowY: "auto", height: "75vh" }}>
          <div className="ui segment">
            <h4 className="ui dividing header">Add Fuel Quota</h4>
            <div className="ui segment">
              <div className="three fields">
                <Input
                  label="Item Type"
                  error={currentErrors.fDedItemType}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { fDedItemType: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  value={itemTypeOpt}
                  readOnly={true}
                />
                <Input
                  label="Job"
                  error={currentErrors.fDedJob}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { fDedJob: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  value={fuelQuotaData.fDedJobCode}
                  readOnly={true}
                />
                <Input
                  label="Vehicle"
                  error={currentErrors.fDedVehicle}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { fDedVehicle: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  value={fuelQuotaData.fDedVehicle}
                  readOnly={true}
                />
              </div>
              <div className="three fields">
                <Input
                  label="Transporter"
                  error={currentErrors.fDedTransporter}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { fDedTransporter: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  value={fuelQuotaData.fDedTransporter}
                  readOnly={true}
                />
              </div>
            </div>
            <div className="three fields">
              <Dropdown
                label="Period"
                required={true}
                error={currentErrors.fDedPeriod}
                resetError={() =>
                  setCurrentErrors((prevState) => {
                    const { fDedPeriod: _, ...rest } = prevState;
                    return rest;
                  })
                }
                placeholder="Period"
                options={dedPeriodOpt}
                style={{ height: "20px" }}
                value={fuelQuotaData.fDedPeriod}
                onChange={(e, data) => {
                  setFuelQuotaData((prevState) => ({
                    ...prevState,
                    fDedPeriod: data.value,
                  }));
                  handlePeriodResult(data.value);
                }}
              />
              <SearchDropdown
                key={1}
                required={true}
                reset={itemFieldReset}
                setReset={setItemFieldReset}
                clearable={true}
                onClear={() => {
                  setFuelQuotaData((prevState) => ({
                    ...prevState,
                    fDedItem: null,
                  }));
                }}
                onResultSelect={(data) => {
                  setFuelQuotaData((prevState) => ({
                    ...prevState,
                    fDedItem: data,
                  }));
                  setCostAgainstItem(data);
                }}
                api={getOtherRefDetails}
                apiDependency={{
                  type: "item_type",
                  value: type,
                }}
                fieldInfo={{
                  tableName: "masterdata.tms_m_items",
                  primaryKey: "tem_id",
                  fieldName: "tem_name",
                  id: fuelQuotaData.fDedItem,
                }}
                label="Item"
                error={currentErrors.fDedItem}
                resetError={() =>
                  setCurrentErrors((prevState) => {
                    const { fDedItem: _, ...rest } = prevState;
                    return rest;
                  })
                }
              />
              <SearchDropdown
                key={1}
                required={true}
                reset={fieldReset}
                setReset={setFieldReset}
                clearable={true}
                onClear={() => {
                  setFuelQuotaData((prevState) => ({
                    ...prevState,
                    fDedSupplier: null,
                  }));
                }}
                onResultSelect={(data) =>
                  setFuelQuotaData((prevState) => ({
                    ...prevState,
                    fDedSupplier: data,
                  }))
                }
                api={getOtherRefSearchDropdown}
                apiDependency={{
                  type: "stakeholder_type",
                  value: "Supplier",
                }}
                fieldInfo={{
                  tableName: "masterdata.tms_m_stakeholder",
                  primaryKey: "stk_id",
                  fieldName: "stk_name",
                  id: fuelQuotaData.fDedSupplier,
                }}
                error={currentErrors.fDedSupplier}
                resetError={() =>
                  setCurrentErrors((prevState) => {
                    const { fDedSupplier: _, ...rest } = prevState;
                    return rest;
                  })
                }
                label="Supplier"
              />
            </div>
            <div className="three fields">
              <Input
                label="Installments"
                required={true}
                readOnly={installmentsDisable || selectedPeriod === 1}
                error={currentErrors.fDedInstallments}
                resetError={() =>
                  setCurrentErrors((prevState) => {
                    const { fDedInstallments: _, ...rest } = prevState;
                    return rest;
                  })
                }
                type={"number"}
                min={0}
                placeholder="Installments"
                name="installments"
                value={fuelQuotaData.fDedInstallments}
                onChange={(e) => {
                  const installments = parseFloat(e.target.value) || 1;
                  const itemCost = fuelQuotaData.fDedItemCost || 0;
                  const quantity = fuelQuotaData.fDedQuantity || 1;
                  const amount = (itemCost * quantity) / installments;

                  setFuelQuotaData((prev) => ({
                    ...prev,
                    fDedInstallments: e.target.value,
                    fDedStart: null,
                    fDedEnd: "",
                    fDedExecutionDate: "",
                    fDedInstallmentAmount: parseFloat(amount.toFixed(2)),
                  }));
                }}
              />

              <Input
                label="Item Cost"
                error={currentErrors.fDedItemCost}
                resetError={() =>
                  setCurrentErrors((prevState) => {
                    const { fDedItemCost: _, ...rest } = prevState;
                    return rest;
                  })
                }
                type={"number"}
                min={0}
                placeholder="Item Cost"
                name="ExecutionDate"
                value={fuelQuotaData.fDedItemCost}
                onChange={(e) =>
                  setFuelQuotaData((prev) => ({
                    ...prev,
                    fDedItemCost: e.target.value,
                  }))
                }
              />
              <Input
                label="Quantity"
                error={currentErrors.fDedQuantity}
                resetError={() =>
                  setCurrentErrors((prevState) => {
                    const { fDedQuantity: _, ...rest } = prevState;
                    return rest;
                  })
                }
                type={"number"}
                min={0}
                placeholder="Quantity"
                name="ExecutionDate"
                value={fuelQuotaData.fDedQuantity}
                onChange={(e) => {
                  const quantity = parseFloat(e.target.value) || 0;
                  const itemCost = fuelQuotaData.fDedItemCost || 0;
                  const installments = fuelQuotaData.fDedInstallments || 1;

                  const amount = quantity * itemCost;
                  const installmentAmount = amount / installments;

                  setFuelQuotaData((prev) => ({
                    ...prev,
                    fDedQuantity: quantity,
                    fDedAmount: parseFloat(amount.toFixed(2)),
                    fDedInstallmentAmount: parseFloat(
                      installmentAmount.toFixed(2)
                    ),
                  }));
                }}
              />
            </div>
            <div className="three fields">
              <Input
                disabled={
                  !fuelQuotaData.fDedInstallments || !fuelQuotaData.fDedPeriod
                }
                required={selectedPeriod !== 1}
                label="Start"
                error={currentErrors.fDedStart}
                resetError={() =>
                  setCurrentErrors((prevState) => {
                    const { fDedStart: _, ...rest } = prevState;
                    return rest;
                  })
                }
                type="date"
                name="start"
                placeholder="Start"
                value={fuelQuotaData.fDedStart}
                onChange={(e) => {
                  setFuelQuotaData((prev) => ({
                    ...prev,
                    fDedStart: e.target.value,
                  }));
                  handleInstallmentDates(e.target.value);
                }}
                readOnly={selectedPeriod === 1}
              />

              <Input
                required={selectedPeriod !== 1}
                label="End"
                error={currentErrors.fDedEnd}
                resetError={() =>
                  setCurrentErrors((prevState) => {
                    const { fDedEnd: _, ...rest } = prevState;
                    return rest;
                  })
                }
                type="date"
                name="start"
                placeholder="Start Time"
                value={fuelQuotaData.fDedEnd}
                onChange={(e) =>
                  setFuelQuotaData((prev) => ({
                    ...prev,
                    fDedEnd: e.target.value,
                  }))
                }
                readOnly={endDateDisable || selectedPeriod === 1}
                disabled={
                  !fuelQuotaData.fDedInstallments || !fuelQuotaData.fDedPeriod
                }
              />

              <Input
                required={selectedPeriod !== 1}
                label="Execution Date"
                error={currentErrors.fDedExecutionDate}
                resetError={() =>
                  setCurrentErrors((prevState) => {
                    const { fDedExecutionDate: _, ...rest } = prevState;
                    return rest;
                  })
                }
                type="date"
                name="ExecutionDate"
                value={fuelQuotaData.fDedExecutionDate}
                onChange={(e) =>
                  setFuelQuotaData((prev) => ({
                    ...prev,
                    fDedExecutionDate: e.target.value,
                  }))
                }
                min={currentDate}
                max={maxDate}
                readOnly={selectedPeriod === 1}
                disabled={
                  !fuelQuotaData.fDedInstallments || !fuelQuotaData.fDedPeriod
                }
              />
            </div>
            <div className="three fields">
              <Input
                label="Amount"
                error={currentErrors.fDedAmount}
                resetError={() =>
                  setCurrentErrors((prevState) => {
                    const { fDedAmount: _, ...rest } = prevState;
                    return rest;
                  })
                }
                type={"number"}
                min={0}
                placeholder="Amount"
                name="amount"
                value={fuelQuotaData.fDedAmount}
                onChange={(e) =>
                  setFuelQuotaData((prev) => ({
                    ...prev,
                    fDedAmount: e.target.value,
                  }))
                }
              />
              <Input
                label="Installment Amount"
                error={currentErrors.fDedInstallmentAmount}
                resetError={() =>
                  setCurrentErrors((prevState) => {
                    const { fDedInstallmentAmount: _, ...rest } = prevState;
                    return rest;
                  })
                }
                readOnly={true}
                min={0}
                placeholder="Installment Amount"
                name="installmentAmount"
                value={fuelQuotaData.fDedInstallmentAmount}
                onChange={(e) =>
                  setFuelQuotaData((prev) => ({
                    ...prev,
                    fDedInstallmentAmount: e.target.value,
                  }))
                }
              />

              <Dropdown
                label="Payment Status"
                required={true}
                error={currentErrors.fDedPaymentStatus}
                resetError={() =>
                  setCurrentErrors((prevState) => {
                    const { fDedPaymentStatus: _, ...rest } = prevState;
                    return rest;
                  })
                }
                placeholder="Payment Status"
                options={paymentStatusOpt}
                style={{ height: "20px" }}
                value={fuelQuotaData.fDedPaymentStatus}
                onChange={(e, data) => {
                  setFuelQuotaData((prevState) => ({
                    ...prevState,
                    fDedPaymentStatus: data.value,
                  }));
                }}
              />
            </div>
            <div className="three fields">
              <Dropdown
                label="Status"
                required={true}
                error={currentErrors.fDedStatus}
                resetError={() =>
                  setCurrentErrors((prevState) => {
                    const { fDedStatus: _, ...rest } = prevState;
                    return rest;
                  })
                }
                placeholder="Status"
                options={dedStatusOpt}
                style={{ height: "20px" }}
                value={fuelQuotaData.fDedStatus}
                onChange={(e, data) => {
                  setFuelQuotaData((prevState) => ({
                    ...prevState,
                    fDedStatus: data.value,
                  }));
                }}
                disabled={true}
              />
              <Dropdown
                label="Active"
                required={true}
                error={currentErrors.fDedActive}
                resetError={() =>
                  setCurrentErrors((prevState) => {
                    const { fDedActive: _, ...rest } = prevState;
                    return rest;
                  })
                }
                placeholder="Active"
                options={dedActiveOpt}
                style={{ height: "20px" }}
                value={fuelQuotaData.fDedActive}
                onChange={(e, data) => {
                  setFuelQuotaData((prevState) => ({
                    ...prevState,
                    fDedActive: data.value,
                  }));
                }}
                disabled={true}
              />
              <Input
                label="Description"
                error={currentErrors.fDedDescription}
                resetError={() =>
                  setCurrentErrors((prevState) => {
                    const { fDedDescription: _, ...rest } = prevState;
                    return rest;
                  })
                }
                placeholder="Description"
                name="description"
                value={fuelQuotaData.fDedDescription}
                onChange={(e) =>
                  setFuelQuotaData((prev) => ({
                    ...prev,
                    fDedDescription: e.target.value,
                  }))
                }
              />
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "flex-end",
                gap: "5px",
                marginTop: "10px",
              }}
            >
              <Button
                template="create"
                disabled={!stakeholderAvailable}
                onClick={submitHandler}
                isLoading={isSubmitLoading}
              />
            </div>
          </div>
        </form>
      )}
    </>
  );
};
export default FuelQuota;
